import React from 'react';
import { SmartLink } from '../SmartLink/SmartLink';
import './Chip.scss';

export const Chip = ({ children }) => {
    return (
        <SmartLink href={`/learn?categories=${children}`} className="chip">
            {children}
        </SmartLink>
    );
};
